export default {"src":"/_next/static/media/devices.4cb0a555.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};